export const OverViewContainer = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    // gap: "44px",
    overflowY: "auto",
    padding: "0",
    margin: "0",
    boxSizing: "border-box",
  } as React.CSSProperties,

  subContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    paddingLeft: "36px",
    paddingRight: "36px",
    boxSizing: "border-box",
  } as React.CSSProperties,

  headerWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "baseline",
    justifyContent: "space-between",
    padding: "32px 36px", // This is padding inside the header; adjust as needed
    backgroundColor: "var(--soft-rose)",
    width: "100%", // Ensure it spans the full width of the container
    boxSizing: "border-box", // Prevent padding from affecting width
  } as React.CSSProperties,

  headerTitle: {
    fontFamily: "Scoop",
    fontSize: "36px",
    fontWeight: 500,
    lineHeight: "40px",
    letterSpacing: "0.01em",
    color: "var(--charcoal-gray)",
  } as React.CSSProperties,

  headerRightSectioon: {
    width: "476px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    alignItems: "flex-end", // Align to the right
    "@media (max-width: 768px)": {
      width: "100%", // Ensure full width on smaller screens
      alignItems: "flex-start", // Align to left for smaller screens
    },
  } as React.CSSProperties,

  datePickersWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "4px",
    "@media (max-width: 768px)": {
      flexDirection: "column", // Stack on smaller screens
      gap: "12px",
    },
  } as React.CSSProperties,

  textField: {
    flex: 1,
    backgroundColor: "var(--white)",
    borderColor: "transparent",
    height: "42px",
  } as React.CSSProperties,

  // visitorsWrapper
  visitorsWrapper: {
    width: "100%",
    // maxWidth: "1440px",
    display: "flex",
    flexDirection: "row",
    alignItems: "baseline",
    padding: "0",
    boxSizing: "border-box",
    whiteSpace: "nowrap",
  } as React.CSSProperties,

  visitorsSubWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "5px",
    flexWrap: "wrap",
  } as React.CSSProperties,

  visitorStatisticsWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    boxShadow: "0px 4px 14px 0px rgba(0, 0, 0, 0.05)",
    border: "1px solid rgba(0, 0, 0, 0.11)",
    borderRadius: "12px",
    flexWrap: "wrap",
  } as React.CSSProperties,

  statisticCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "10px",
    padding: "16px",
    flexShrink: 0,
  } as React.CSSProperties,

  statisticCardSubSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
  } as React.CSSProperties,

  statisticCardTitle: {
    fontFamily: "Scoop",
    fontSize: "17px",
    fontWeight: 500,
    lineHeight: "21px",
    color: "var(--black60)",
  } as React.CSSProperties,

  statisticCardBottom: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "8px",
  } as React.CSSProperties,

  statisticCount: {
    fontFamily: "Scoop",
    fontSize: "26px",
    fontWeight: 500,
    lineHeight: "21px",
    color: "var(--black)",
  } as React.CSSProperties,

  statisticPercent: {
    fontFamily: "sans-serif",
    fontSize: "17px",
    fontWeight: 600,
    lineHeight: "21px",
    color: "var(--forest-green)",
  } as React.CSSProperties,
  statisticPercent2: {
    fontFamily: "sans-serif",
    fontSize: "17px",
    fontWeight: 600,
    lineHeight: "21px",
    color: "var(--vibrant-orange)",
  } as React.CSSProperties,
};
